module.exports = __webpack_public_path__ + "img/core_functionality.png";